import React from "react";
import { chat_me, contact_us, spin } from "../assets/img";


const FixedIcons = () => {
  return (
    <div className="fixed-icons">
      <a href="/spin">
        <img src={spin} alt="Spin" />
      </a>

      <a href="/chat">
        <img src={chat_me} alt="Chat" />
      </a>

      <a href="/contact">
        <img src={contact_us} alt="Contact" />
      </a>
    </div>
  );
};

export default FixedIcons;
